import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveUpLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M5 11V5H11' }],
    ['path', { d: 'M5 5L19 19' }],
  ],
];

export default MoveUpLeft;
